<template>
  <div>
    <div class="flex justify-between h-[60px] py-[20px] px-[16px]">
      <div class="flex items-center">
        <el-button text @click="emit('close')" class="mr-[20px]">
          <el-icon><Close /></el-icon>
        </el-button>
        <div class="text-[16px] font-semibold text-[#333C5B] leading-[22px]">
          {{ $t(`common.${drawerMode}`) }}{{ drawerMode === 'show' ? '' : '用户' }}
        </div>
      </div>

      <div class="actions">
        <el-space v-if="drawerMode !== 'show'">
          <el-button :loading="loading" type="primary" @click="submit">保存</el-button>
          <el-button v-if="target?.id" @click="drawerMode = 'show'">取消</el-button>
        </el-space>
        <div v-else>
          <el-button v-if="operations.includes('user:upsert')"
            type="primary" @click="drawerMode = 'edit'">编辑</el-button>
        </div>
      </div>
    </div>

    <div class="bg-[#F9F9F9] h-[calc(100vh-60px-90px)] p-[20px] overflow-auto">
      <div v-if="['edit', 'new'].includes(drawerMode)">
        <Form ref="form" :target="target" :options="options" @close="emit('close')" @submitUpdate="submitUpdate" />
      </div>
      <Detail ref="detailRef" v-else :target="target" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Close } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import Form from './Form.vue'
import Detail from './Detail.vue'

const props = defineProps({
  options: {
    type: Object,
    default: null,
  }
})

const { t } = useI18n()
const { operations } = useShareData()
const form = ref(null)
const detailRef = ref(null)
const loading = ref(false)
const drawerMode = ref('show')
const target = ref({})
const emit = defineEmits(["close", "submitUpdate"])

const submit = () => {
  loading.value = true
  form.value?.submit()
}

const submitUpdate = (success) => {
  loading.value = false
  if (success) emit('close')
}

const updateDrawerMode = async (mode, id) => {
  drawerMode.value = mode
  target.value = {}
  try {
    const data = await get(routes.admin_sys_user(id))
    target.value = data.row
  } catch (error) {
    ElMessage.error(t('message.loadingFailed'))
  }
}

defineExpose({ updateDrawerMode })
</script>
